(function () {
  let imageBanner = () => {
    $(".image-banner__heading")
      .off("mouseenter.imageBanner")
      .on("mouseenter.imageBanner", function () {
        $(this).addClass("active");
        $(this).siblings(".image-banner__heading").removeClass("active");
      });
  };

  document.addEventListener("shopify:section:load", function () {
    imageBanner();
  });

  imageBanner();
})();
